import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { getUmbracoEnv } from '@/config/umbraco-env';

Vue.use(Vuex);

const baseURL = getUmbracoEnv();

export default new Vuex.Store({
    state: {
        partners: [],
        banners: {},
        retailers: {},
        supportFAQ: [],
        combineFAQ: [],
        notification: {},
    },
    mutations: {
        setPartners(state, partners) {
            state.partners = partners;
        },
        setRetailers(state, retailers) {
            state.retailers = retailers;
        },
        setBanners(state, banners) {
            state.banners = banners;
        },
        setSupportFAQ(state, supportFAQ) {
            state.supportFAQ = supportFAQ;
        },
        setCombineFAQ(state, combineFAQ) {
            state.combineFAQ = combineFAQ;
        },
        setNotification(state, notification) {
            state.notification = notification;
        },
    },
    actions: {
        fetchPartners({ commit }) {
            return axios
                .get(`${baseURL}/karma-koin/v1/partners.json`)
                .then((response) => commit('setPartners', response.data));
        },
        fetchRetailers({ commit }) {
            return axios
                .get(`${baseURL}/karma-koin/v1/retailers.json`)
                .then((response) => commit('setRetailers', response.data));
        },
        fetchBanners({ commit }) {
            return axios
                .get(`${baseURL}/karma-koin/v1/banners.json`)
                .then((response) => commit('setBanners', response.data));
        },
        fetchSupportFAQ({ commit }) {
            return axios
                .get(`${baseURL}/karma-koin/v1/support-faq.json`)
                .then((response) => commit('setSupportFAQ', response.data));
        },
        fetchCombineFAQ({ commit }) {
            return axios
                .get(`${baseURL}/karma-koin/v1/combine-faq.json`)
                .then((response) => commit('setCombineFAQ', response.data));
        },
        fetchNotification({ commit }) {
            return axios
                .get(`${baseURL}/karma-koin/v1/notification.json`)
                .then((response) => commit('setNotification', response.data));
        },
    },
});
